import type * as S from "@shipyard/shared";

/** Owners and admins manage the active organization (apps, credentials, providers, members). */
export const isOrgAdmin = (me: S.Me | null | undefined) => me?.organization?.role === "owner" || me?.organization?.role === "admin";

/** Instance administrators manage users and instance settings. */
export const isInstanceAdmin = (me: S.Me | null | undefined) => me?.role === "admin";
